import numeral from 'numeral'
import 'numeral/locales/es-es'
import {langAndRegion} from 'helpers/i18n'

if (['es-es'].includes(langAndRegion)) numeral.locale(langAndRegion)

export const toNumber = (n: number | string) => numeral(n).format('0,0.[00]')

export const toRound = (n: number | string) => numeral(n).format('0,0.00')

export const toMoney = (n: number | string) => numeral(n).format('0,0.00 $')

export const round = (n: number, decimals: number = 4) =>
  Number(Math.round(Number(n + 'e' + decimals)) + 'e-' + decimals)

export const fromMoney = (value) => {
  if (typeof value === 'string') {
    const splited = value.split(' ')
    console.log('splited: ', splited)
    return Number(splited[0])
  }
  return value
}

export const toPercentage = (n: number | string) =>
  numeral(n).format('0.[00] %')

export const toPorciento = ( n: number | string ) => `${n}%`

const parseDate = (d: Date | string) =>
  typeof d === 'string' ? (Date.parse(d) ? new Date(d) : new Date()) : d

export const toDate = (d: Date | string) => parseDate(d).toLocaleDateString()

export const toTime = (d: Date | string) => parseDate(d).toLocaleTimeString()

export const toDateTime = (d: Date | string) => parseDate(d).toLocaleString()



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/helpers/Format.ts